export default "__VITE_ASSET__BsSWooHD__"